//init clipboardJS
new window.ClipboardJS(".copy-btn");

//custom helper functions
Object.size = function (obj) {
  let size = 0,
    key;
  for (key in obj) {
    size++;
  }
  return size;
};
String.capitalize = (str) => {
  if (typeof str === "string") {
    let result = str;
    result = result[0].toUpperCase() + result.slice(1);
    return result;
  }
  return undefined;
};

const capitalizeString = String.capitalize;

//go to previous page
window.goBack = () => {
  window.history.go(-1);
};
//notify defaults
window.$.notify.defaults({
  hideDuration: 100,
  showDuration: 100,
  // autoHide: false,
});

//on copy of a link, text, or code
window.copiedLink = () => {
  window.$.notify("Copied to clipboard", "success-alert");
};
window.copyToClipboard = (data) => {
  const text = data;
  navigator.clipboard
    .writeText(text)
    .then(() => window.$.notify("Copied to clipboard", "success-alert"))
    .catch((err) => console.error("Failed to copy:", err));
};
function deleteFromArray(item, array) {
  return array.filter((array_item) => {
    return array_item !== item;
  });
}

function getDateData(date_string, full, stringFormat) {
  const days = ["Sun", "Mon", "Tue", "Wed", "Thur", "Fri", "Sat"];
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  const fullMonths = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  const d = new Date(date_string);
  const date = d.getDate();
  const day = days[d.getDay()];
  const month = d.getMonth();
  const year = d.getFullYear();

  if (stringFormat)
    return ` ${day}, ${date}${(() => {
      const dateCopy = date.toString();
      const lastNumber = dateCopy[dateCopy.length - 1];

      if (dateCopy[0] == -1 && dateCopy.length === 2) {
        return "th";
      } else if (lastNumber === 1) {
        return "st";
      } else if (lastNumber === 2) {
        return "nd";
      } else if (lastNumber === 3) {
        return "rd";
      }
      return "th";
    })()} of ${!full ? months[month] : fullMonths[month]}${
      full ? `, ${year}` : ""
    }`;

  return {
    month: months[month],
    date,
    day,
  };
}
function getDateString(date_string, full, dataFormat) {
  const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const fullMonths = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  const d = new Date(date_string);
  const date = d.getDate();
  const day = days[d.getDay()];
  const month = d.getMonth();
  const year = d.getFullYear();

  if (dataFormat) {
    return {
      day,
    };
  }

  return ` ${day}, ${date}${(() => {
    const dateCopy = date.toString();
    const lastNumber = dateCopy[dateCopy.length - 1];

    if (dateCopy[0] == 1 && dateCopy.length == 2) {
      return "th";
    } else if (lastNumber == 1) {
      return "st";
    } else if (lastNumber == 2) {
      return "nd";
    } else if (lastNumber == 3) {
      return "rd";
    }
    return "th";
  })()} of ${!full ? months[month] : fullMonths[month]}${
    full ? `, ${year}` : ""
  }`;
}

export { deleteFromArray, getDateData, getDateString, capitalizeString };
